export default "__VITE_ASSET__DTz7FqKY__"